import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { FileDown, Menu, X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Wordmark = () => (
  <div className="flex items-center gap-3">
    <img src="/assets/logo-jade.png" alt="Jade Residence" className="h-10 w-auto shrink-0" data-testid="nav-logo" />
    <div>
      <p className="font-display text-[13px] tracking-[0.26em] text-jadedeep">JADE RESIDENCE</p>
      <p className="mt-1 text-[9px] font-semibold uppercase tracking-[0.3em] text-graphite/50">
        Kuta · Lombok
      </p>
    </div>
  </div>
);

const NavList = ({ chapters, active, onNavigate, large }) => (
  <nav className={large ? "space-y-1" : "mt-10 flex-1 space-y-0.5 overflow-y-auto pr-2"}>
    {chapters.map((c) => {
      const isActive = active === c.id;
      return (
        <button
          key={c.id}
          data-testid={`nav-link-${c.id}`}
          onClick={() => onNavigate(c.id)}
          className={`group flex w-full items-baseline gap-3 border-l-2 py-1.5 pl-4 text-left transition-colors duration-300 ${
            large ? "py-2.5" : ""
          } ${
            isActive
              ? "border-gold text-jade"
              : "border-transparent text-graphite/50 hover:border-gold/50 hover:text-jade"
          }`}
        >
          <span className={`font-mono ${large ? "text-xs" : "text-[10px]"} ${isActive ? "text-gold" : "text-gold/60"}`}>
            {c.id}
          </span>
          <span
            className={`${
              large ? "font-serif text-3xl" : "text-[13px]"
            } ${isActive ? "font-medium" : ""} transition-transform duration-300 group-hover:translate-x-1`}
          >
            {c.title}
          </span>
        </button>
      );
    })}
  </nav>
);

export const SideNav = ({ chapters, active, onNavigate }) => (
  <aside className="fixed inset-y-0 left-0 z-40 hidden w-72 flex-col border-r border-sand bg-ivory/95 px-8 py-10 backdrop-blur lg:flex">
    <Wordmark />
    <NavList chapters={chapters} active={active} onNavigate={onNavigate} />
    <a
      data-testid="pdf-download-btn-nav"
      href={`${API}/dossier/pdf`}
      className="mt-8 inline-flex items-center justify-center gap-2 bg-jade px-5 py-3 text-[11px] font-semibold uppercase tracking-[0.2em] text-ivory transition-colors duration-300 hover:bg-gold hover:text-graphite"
    >
      <FileDown className="h-4 w-4" />
      Exportar PDF
    </a>
  </aside>
);

export const MobileNav = ({ chapters, active, onNavigate }) => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    setTimeout(() => onNavigate(id), 250);
  };
  return (
    <>
      <div className="fixed inset-x-0 top-0 z-40 flex items-center justify-between border-b border-sand bg-ivory/95 px-5 py-4 backdrop-blur lg:hidden">
        <Wordmark />
        <button
          data-testid="mobile-menu-btn"
          onClick={() => setOpen(true)}
          className="border border-sand p-2 text-jade"
          aria-label="Abrir índice"
        >
          <Menu className="h-5 w-5" />
        </button>
      </div>
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed inset-0 z-50 flex flex-col bg-ivory px-7 py-6"
            data-testid="mobile-menu"
          >
            <div className="flex items-center justify-between">
              <Wordmark />
              <button
                data-testid="mobile-menu-close"
                onClick={() => setOpen(false)}
                className="border border-sand p-2 text-jade"
                aria-label="Cerrar índice"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
            <div className="mt-8 flex-1 overflow-y-auto">
              <NavList chapters={chapters} active={active} onNavigate={go} large />
            </div>
            <a
              data-testid="pdf-download-btn-mobile"
              href={`${API}/dossier/pdf`}
              className="mt-6 inline-flex items-center justify-center gap-2 bg-jade px-5 py-3.5 text-[11px] font-semibold uppercase tracking-[0.2em] text-ivory"
            >
              <FileDown className="h-4 w-4" />
              Exportar PDF
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
